// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { notesStyles } from "@conklin/Overrides/Widgets/RequestRma/RequestRmaNotes";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

notesStyles.wrapper = {
    css: css`
        padding-bottom: 0;
    `,
};

notesStyles.notesTextArea = {
    css: css`
        resize: vertical;
        max-height: 500px;
    `,
};

notesStyles.titleText = {
    variant: "h5",
    css: css`
        padding-bottom: 9px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
